// Known experiences. Represents the default experience a user should have upon logging into digits.com
// https://github.com/digits/go-services/blob/main/shared/auth/permission/persona.go
export enum Experience {
  ClientPortal = "cp",
  OperatorPortal = "op",
  AccountantPortal = "ap",
}
